import { FinancialItemCategory } from "./FinancialItemCategory";

export interface FinancialItemTypeData {
  title: string;
  id: string;
  description: string;
  order: number;
  category: FinancialItemCategory;
}
export const financialItemTypes: FinancialItemTypeData[] = [
  {
    title: "Real Estate",
    id: "real_estate",
    description: "",
    order: 0,
    category: "asset",
  },
  {
    title: "Household Item",
    id: "household_items",
    description: "",
    order: 1,
    category: "asset",
  },
  {
    title: "Jewelry, Antique, Art",
    id: "jewelry_antiques_art",
    description: "",
    order: 2,
    category: "asset",
  },
  {
    title: "Vehicle, Boat, Trailer",
    id: "vehicles_boats_trailers",
    description: "",
    order: 3,
    category: "asset",
  },
  {
    title: "Savings Account",
    id: "savings_account",
    description: "",
    order: 4,
    category: "asset",
  },
  {
    title: "Checking Account",
    id: "checking_account",
    description: "",
    order: 5,
    category: "asset",
  },
  {
    title: "Credit Union Account",
    id: "credit_union_account",
    description: "",
    order: 6,
    category: "asset",
  },
  { title: "Cash", id: "cash", description: "", order: 7, category: "asset" },
  {
    title: "Tax Refund",
    id: "tax_refund",
    description: "",
    order: 8,
    category: "asset",
  },
  {
    title: "Life Insurance with Cash Value",
    id: "life_insurance_cash_value",
    description: "",
    order: 9,
    category: "asset",
  },
  {
    title: "Security, Stock, Bond",
    id: "securities_stocks_bonds",
    description: "",
    order: 10,
    category: "asset",
  },
  {
    title: "Retirement and Pension",
    id: "retirement_pension",
    description: "",
    order: 11,
    category: "asset",
  },
  {
    title: "Annuity, IRA, Deferred Compensation",
    id: "annuities_iras_deferred_comp",
    description: "",
    order: 12,
    category: "asset",
  },
  {
    title: "Accounts Receivable and Notes",
    id: "accounts_receivable_notes",
    description: "",
    order: 13,
    category: "asset",
  },
  {
    title: "Business Interest",
    id: "business_interest",
    description: "",
    order: 14,
    category: "asset",
  },
  {
    title: "Other Asset",
    id: "other_asset",
    description: "",
    order: 15,
    category: "asset",
  },

  // Debts
  {
    title: "Student Loan",
    id: "student_loan",
    description: "",
    order: 16,
    category: "liability",
  },
  {
    title: "Taxes Due",
    id: "taxes_due",
    description: "",
    order: 17,
    category: "liability",
  },
  {
    title: "Support Arrearage",
    id: "support_arrearage",
    description: "",
    order: 18,
    category: "liability",
  },
  {
    title: "Unsecured Loan",
    id: "unsecured_loan",
    description: "",
    order: 19,
    category: "liability",
  },
  {
    title: "Credit Card Debt",
    id: "credit_card_liability",
    description: "",
    order: 20,
    category: "liability",
  },
  {
    title: "Other Debt",
    id: "other_liability",
    description: "",
    order: 21,
    category: "liability",
  },
];
export type FinancialItemType = (typeof financialItemTypes)[number]["id"];

export const plaidEligibleCategories: FinancialItemType[] = [
  "savings_account",
  "checking_account",
  "credit_union_account",
  "securities_stocks_bonds", // (Brokerage accounts)
  "retirement_pension", // (401k, pensions)
  "annuities_iras_deferred_comp", // (IRA, deferred comp)
  "credit_card_liability", // (Credit cards)
  "student_loan", // (Loan accounts)
  "unsecured_loan", // (e.g., personal loans)
];
